import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { ModalProvider } from 'styled-react-modal'
import { getInitials } from '@util/stringUtil'
import AuthUtil from '@util/AuthUtil'

import 'material-icons/iconfont/outlined.css'
import 'material-icons/iconfont/filled.css'

import {
  Container,
  InfoContainer,
  InfoDisplay,
  Name,
  CompanyName,
  UserInitials,
  ContainerLogOut,
  Title,
  Menu,
  ButtonContainer,
  TransparentModalBackground,
  ContainerMenu,
  ExamsContainer,
  Wrapper,
} from './styles'

import colors from '@settings/styleSettings'

import { setLoggedIn as setLoggedInAction } from '@actions/user'
import { setAuth as setAuthAction } from '@actions/auth'

const LogoutModal = ({
  userName,
  profile,
  openChangePasswordModal,
  openProfileModal,
  setLoggedIn,
  setAuth,
  company,
  authData,
}) => {
  const isRestricted = !!(authData && (authData.company || authData.programme))
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [menuModal, setMenuModal] = useState(false)
  const [optionsModal, setOptionsModal] = useState(false)

  const { insurance } = useParams()

  const handleUserProfileModal = () => {
    setMenuModal(false)
    openProfileModal()
  }

  const handleClickModalChangePassword = () => {
    setMenuModal(false)
    openChangePasswordModal()
  }

  const logUserOut = () => {
    localStorage.removeItem('acessToken')
    window.localStorage.setItem('logout', 'logout')
    AuthUtil.clearSession()
    setLoggedIn(false)
    setAuth(null)
    navigate(`/${insurance}/acompanhamento`)
  }

  const handleOpenUploadExams = () => {
    if (!pathname.includes('importar-exames')) {
      setOptionsModal(false)
      navigate(`/${insurance}/acompanhamento/importar-exames`)
    }
  }

  const handleOpenEquipments = () => {
    if (!pathname.includes('equipamentos')) {
      setOptionsModal(false)
      navigate('/unimed-assis/acompanhamento/emprestimos')
    }
  }

  const handleOpenAutoImportExams = () => {
    if (!pathname.includes('importacao-automatica')) {
      setOptionsModal(false)
      navigate('/unimed-assis/acompanhamento/importacao-automatica')
    }
  }

  const handleClickMenuModal = () => {
    setOptionsModal(false)
    setMenuModal(!menuModal)
  }

  const handleClickOptionsModal = () => {
    setMenuModal(false)
    setOptionsModal(!optionsModal)
  }

  const myRef = useRef(null)
  const handleClickOutside = (event) => {
    if (myRef.current && !myRef.current.contains(event.target)) {
      setMenuModal(false)
      setOptionsModal(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [myRef])

  return (
    <Container ref={myRef}>
      <Wrapper>
        {!isRestricted && (
          <ExamsContainer>
            <span
              onClick={handleClickOptionsModal}
              className="material-symbols-outlined"
              style={{
                color: colors.background,
              }}
            >
              construction
            </span>
          </ExamsContainer>
        )}
        <InfoContainer onClick={handleClickMenuModal}>
          <InfoDisplay>
            <Name>{userName}</Name>
            <CompanyName>{company}</CompanyName>
          </InfoDisplay>
          <UserInitials>{getInitials(profile && profile.name)}</UserInitials>
        </InfoContainer>
      </Wrapper>
      {menuModal && (
        <ContainerMenu>
          <ModalProvider>
            <ContainerLogOut
              backgroundprops={TransparentModalBackground}
            >
              <Menu>
                <ButtonContainer onClick={handleUserProfileModal}>
                  <span className="material-icons-outlined">
                    person_outline
                  </span>
                  <Title>Perfil</Title>
                </ButtonContainer>
                <ButtonContainer onClick={handleClickModalChangePassword}>
                  <span className="material-icons">lock</span>
                  <Title>Alterar senha</Title>
                </ButtonContainer>
                <ButtonContainer onClick={logUserOut}>
                  <span className="material-icons">logout</span>
                  <Title>Sair</Title>
                </ButtonContainer>
              </Menu>
            </ContainerLogOut>
          </ModalProvider>
        </ContainerMenu>
      )}

      {optionsModal && (
      <ContainerMenu>
        <ModalProvider>
          <ContainerLogOut
            backgroundprops={TransparentModalBackground}
          >
            <Menu>
              <ButtonContainer onClick={handleOpenUploadExams}>
                <span className="material-symbols-outlined">
                  lab_profile
                </span>
                <Title>Importar exames</Title>
              </ButtonContainer>
              <ButtonContainer onClick={handleOpenAutoImportExams}>
                <span className="material-symbols-outlined">
                  dns
                </span>
                <Title style={{ fontFamily: 'Circular-Std' }}>Importação automática do servidor</Title>
              </ButtonContainer>
              <ButtonContainer onClick={handleOpenEquipments}>
                <span className="material-icons-outlined">
                  home_repair_service
                </span>
                <Title>Empréstimos</Title>
              </ButtonContainer>
              <ButtonContainer onClick={() => {}}>
                <span className="material-icons">call</span>
                <Title>Central de ajuda</Title>
              </ButtonContainer>
            </Menu>
          </ContainerLogOut>
        </ModalProvider>
      </ContainerMenu>
      )}
    </Container>
  )
}

LogoutModal.propTypes = {
  profile: PropTypes.shape({
    name: PropTypes.string,
  }),
  userName: PropTypes.string.isRequired,
  company: PropTypes.string,
  openChangePasswordModal: PropTypes.func.isRequired,
  setLoggedIn: PropTypes.func.isRequired,
  setAuth: PropTypes.func.isRequired,
  openProfileModal: PropTypes.func.isRequired,
  authData: PropTypes.shape({
    company: PropTypes.shape({ id: PropTypes.number }),
    programme: PropTypes.shape({ id: PropTypes.number }),
  }),
}

LogoutModal.defaultProps = {
  profile: {
    name: null,
  },
  company: '',
  authData: null,
}

const mapStateToProps = ({ auth }) => ({
  authData: auth.data,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    setLoggedIn: setLoggedInAction,
    setAuth: setAuthAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(LogoutModal)
